import React from 'react'

import VisibilitySensor from 'react-visibility-sensor'
import Results from '../Results'

import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { resultsVisibilityChanged } from '../../actions'

interface IProps {
  onChange(isVisible: boolean): void
}

export const TrackedResults: React.FunctionComponent<IProps> = ({
  onChange
}) => {
  return (
    <VisibilitySensor onChange={onChange} partialVisibility={true}>
      <Results />
    </VisibilitySensor>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: (isVisible: boolean) => {
    dispatch(resultsVisibilityChanged(isVisible))
  }
})

const TrackedResultsSmart = connect(null, mapDispatchToProps)(TrackedResults)

export default TrackedResultsSmart
